export default "__VITE_ASSET__B75NTWN0__"